// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2rkfa","right":"styles_right__fSM4d"};